import React, { useRef, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { clampFrac, easeInQuad, pinPositionText, useAnimationFrame } from '../util'
import useStore from '../AppStore'


export default function Presents(props) {
  
  const {start, end} = props

  const divRef = useRef(null)

  useAnimationFrame(deltaTime => {

    const top = useStore.getState().top
    const opacity = top < start - 500 || top > end + 300 ? 0 : textOpacity(top, end, end + 300)
    
    if(divRef.current){
      divRef.current.style.display = opacity > 0 ? 'block' : 'none'
      divRef.current.style.opacity = opacity
      if(opacity){
        const y = easeInQuad(clampFrac(top,start,end+300))
        divRef.current.style.transform = `translate3d(0px,${-y*500}px,0)`
      }  
    }

  })

  return (
    <div ref={divRef} className={`presents-block`}>
      {props.content}
    </div>
  )
}


function textOpacity(top, low, high) {
  return top > low ? 1 - clampFrac(top,low,high) : 1
}